import "./payment.css";
import Calendar from 'react-calendar';
import {useState} from "react";
import 'react-calendar/dist/Calendar.css';
import { useOutletContext } from "react-router-dom";
import { useContext } from "react";
import {stateContext} from "../../App";

function Scadual() {

    const {setTab} = useOutletContext();

    return (
        <>
            <div className="sm:container relative container mx-auto sm:pl-0 sm:pr-0 pl-5 pr-5 mt-15 mb-15 grid lg:grid-cols-3 grid-cols-1 gap-10">
                <Calander />
                <InstaBanner setTab={setTab}  />
            </div>
        </>
    )
}

function Calander() {

    const [value, onChange] = useState(new Date());

    return (
        <div className="md:col-span-2 col-span-1">
            <div className="flex items-center justify-between sm:flex-row flex-col">
                <h1 className="text-2xl gray-color1 font-bold">Schedual your campain</h1>
                <div className="flex items-center gap-5 sm:mt-0 sm:mb-0 mt-5 mb-5">
                    <Campain text="M" state="active-compain"/>
                    <Campain text="W" state="not-active-campain"/>
                    <Campain text="D" state="not-active-campain"/>
                </div>
            </div>
            <div className="flex items-center justify-between mt-5 sm:flex-row flex-col-reverse sm:gap-3 gap-7">
                <Input text="March" placeholder="May">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="#cf102d">
                        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </Input>
                <button className="pl-8 pr-8 pt-2 pb-2 rounded-3xl font-semibold active-page">Download Play</button>
            </div>
            <div className="mt-3">
                <Calendar onChange={onChange} value={value} />
            </div>
        </div>
    )
}

function Campain({text, state}) {
    return (
        <h1 className={`w-8 h-8 flex justify-center items-center font-bold rounded-full ${state}`}>{text}</h1>
    )
}

function Input({text, placeholder, children}) {
    return (
        <div>
            <h4 className="text-sm font-semibold gray-color1">{text}</h4>
            <div className="p-3 mt-3 flex rounded-md w-full gray-color2">
                <input style={{width:"20%"}} className="flex-1 w-auto mr-3 bg-transparent" type="text" placeholder={placeholder} />
                {children}
            </div>
        </div>
    )
}

function InstaBanner({setTab}) {
    const {setShowModal} = useContext(stateContext);
    return (
        <div className="col-span-1">
            <h1 className="text-2xl gray-color1 font-bold">Instagram, App - Banner</h1>
            <div style={{height: "95%"}} className="flex h-full flex-col justify-between">
                <div className="gray-color2 rounded-lg mt-5 p-5">
                    <h1 className="text-md gray-color1 font-bold">Instagram, App - Banner</h1>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Schedual Quantity</p>
                        <p>200000</p>
                    </div>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Date Scaduled</p>
                        <p>30 Apr</p>
                    </div>
                    <div className="text-xs font-bold text-zinc-400 flex items-center justify-between mt-3">
                        <p>Rate</p>
                        <p>₹ 15</p>
                    </div>
                    <div className="red-color1 font-bold text-sm flex items-center justify-between mt-5">
                        <div>
                            <p>Sub Total Inc.</p>
                            <p>taxes (18% GST)</p>
                        </div>
                        <p>₹ 3,40,000</p>
                    </div>
                </div>
                <button onClick={() => {setTab(3); setShowModal(5)}} className="w-full rounded-2xl mt-10 pt-2 pb-2 font-semibold visited">Confirm Comapin</button>
            </div>
        </div>
    )
}

export default Scadual;